module.exports = __webpack_public_path__ + "img/13.0e6ecc3e.png";